import thousandSeparator from '../../../Utils/numberFormat';

/**
 * How a booking's profit reads in the orders list — ONE rule for the mobile
 * card and the desktop Price column, which used to carry their own copies.
 *
 * A gratis trip (revenue 0, `margin: null` from the API) still has an
 * operator to pay, so it shows the loss and says "gratis" where a percentage
 * would be. Colouring it by margin was the bug: there is no percentage of
 * nothing, so it is coloured by whether money was actually lost.
 *
 * @param summary booking.profit_summary, or null/undefined
 * @returns `{ tone, text, title }` for display, or null when there is nothing
 *          to say.
 */
export default function profitDisplay(summary) {
  if (!summary) return null;

  const { profit, margin, currency } = summary;
  const hasMargin = typeof margin === 'number' && Number.isFinite(margin);

  let sign = '';
  if (profit > 0) sign = '+';
  else if (profit < 0) sign = '−';

  const amount = thousandSeparator(Math.abs(Math.round(profit))) || '0';

  let tone;
  if (!hasMargin) tone = profit < 0 ? 'danger' : 'secondary';
  else if (margin < 10) tone = 'danger';
  else if (margin < 20) tone = 'warning';
  else tone = 'success';

  const tail = hasMargin ? `${Math.round(margin)}%` : 'gratis';

  return {
    tone,
    text: `${sign}${amount} ${currency} · ${tail}`,
    title: hasMargin
      ? `Profit margin: ${margin.toFixed(1)}%`
      : 'No price on this trip — the amount shown is what it cost',
  };
}
